import React, { useState } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { CognitoUser, CognitoUserPool, AuthenticationDetails } from 'amazon-cognito-identity-js'
import Alert from '@mui/material/Alert';
import { useNavigate } from "react-router-dom";

export const Login: React.FC = () => {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const userPool = new CognitoUserPool({
    UserPoolId: 'us-east-1_VcwEzBc6u',
    ClientId: '7rq2g8rks630t1il6pstc8r6c2'
  });

  const Authenticate = () => {
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: userPool,
    });
    const authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: password
    });
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (userSession) => {
        localStorage.setItem('username', username);
        localStorage.setItem('accessToken', userSession.getIdToken().getJwtToken())
        navigate('/');
      },
      onFailure: (err) => {
        setError(err.toString());
      }
    })
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img src='KANJ-Transparent.png' />
        <Typography component="h1" variant="h5">
          KANJ - Sign in
        </Typography>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
            onChange={(event) => setUsername(event.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={(event) => setPassword(event.target.value)}
          />
          {
            error && (
              <Alert severity="error">{error}</Alert>
            )
          }
          <Button
            type="button"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={Authenticate}
          >
            Sign In
          </Button>
        </Box>
      </Box>
    </Container>
  );
}